const RestaurantDrinkTemplate = ({ name }) => {
  return `
    <div class="food">
      <div class="image">
        <picture>
          <source media="(max-width: 780px)" srcset="./assets/drink-small.jpg">
          <img
            class="lazyload" 
            data-src="/assets/drink-large.jpg"
            alt="${name}"
          >
        </picture>
      </div>
      <div class="name-rating-category">
        <div class="name">${name}</div>
        <div class="category">squash . cold</div>
        <div class="rating"><i class="fa fa-star" aria-hidden="true"></i> 9.3</div>
      </div>
    </div>
  `
}

export default RestaurantDrinkTemplate
